import { useQuery } from '@tanstack/react-query';
import { getFolderContents } from '../api/filesApi';

export const folderContentsKeys = {
  all: ['folder-contents'] as const,
  list: (siteId: number, folderId?: string) =>
    [...folderContentsKeys.all, siteId, folderId] as const,
};

export function useFolderContents(
  siteId: number,
  folderId?: string,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: folderContentsKeys.list(siteId, folderId),
    queryFn: () => getFolderContents(siteId, folderId),
    enabled: options?.enabled ?? true,
  });
}
